(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pnm-brand-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.pnmBrandHeroReady) return;
  window.pnmBrandHeroReady = true;
  const bikeFilterKeys = ['gff_705339', 'gff_705340', 'gff_705341', 'gff_705342'];
  const selectionKey = 'pnm_selected_bike_v1';
  const decorateLinks = () => {
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (!previewTheme) return;
    document.querySelectorAll('[data-pnm-brand-link]').forEach(link => {
      const target = new URL(link.href, location.origin);
      if (target.origin !== location.origin) return;
      target.searchParams.set('preview_theme_id', previewTheme);
      link.href = target.pathname + target.search;
    });
  };
  const browseBrand = event => {
    const link = event.target.closest('[data-pnm-brand-link]');
    if (!link || event.defaultPrevented) return;
    if (event.type === 'click' && event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && link.hasAttribute('data-pnm-brand-selector') && window.PNMBikeSelector) {
      event.preventDefault();
      window.PNMBikeSelector.open(link);
      return;
    }
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const target = new URL(link.href, location.origin);
    if (target.origin !== location.origin) return;
    [...bikeFilterKeys, selectionKey].forEach(key => {
      try { localStorage.removeItem(key); } catch (error) {}
    });
    window.defaultFilterParams = {};
    const current = new URL(location.href);
    [...bikeFilterKeys, 'gf_852962', 'gf_select-your-model'].forEach(key => current.searchParams.delete(key));
    if (current.href !== location.href) history.replaceState(history.state, '', current.href);
    window.dispatchEvent(new StorageEvent('storage', { key: selectionKey, newValue: null }));
  };
  document.addEventListener('click', browseBrand, true);
  document.addEventListener('auxclick', browseBrand, true);
  document.addEventListener('shopify:section:load', decorateLinks);
  window.addEventListener('pageshow', decorateLinks);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorateLinks, { once: true });
  else decorateLinks();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-contact-bike-prefill"]) return;
  try {
    
(() => {
  const fillSelectedBike = () => {
    const form = document.getElementById('ContactForm');
    if (!form || form.dataset.pnmBikePrefillReady) return;
    form.dataset.pnmBikePrefillReady = 'true';
    const modelField = form.querySelector('[name="contact[motormodel]"]');
    const yearField = form.querySelector('[name="contact[motoryear]"]');
    if (!modelField || !yearField || modelField.value.trim() || yearField.value.trim()) return;
    if (document.activeElement === modelField || document.activeElement === yearField) return;
    const keys = ['gff_705339', 'gff_705341', 'gff_705342'];
    const params = new URLSearchParams(window.location.search);
    let values;
    if (keys.some((key) => params.has(key))) {
      values = keys.map((key) => params.get(key) || '');
    } else {
      try {
        values = keys.map((key) => window.localStorage.getItem(key) || '');
      } catch (error) {
        return;
      }
    }
    const [brand, model, year] = values.map((value) => value.trim());
    if (!/^(Honda|Yamaha|Kawasaki|Suzuki)( ATV)?$/i.test(brand)) return;
    if (!model || model.length > 80 || /[\x00-\x1f<>|,]/.test(model)) return;
    modelField.value = model.toLowerCase().startsWith(brand.toLowerCase() + ' ') ? model : brand + ' ' + model;
    if (/^\d{4}$/.test(year)) yearField.value = year;
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillSelectedBike, { once: true });
  } else {
    fillSelectedBike();
  }
  document.addEventListener('shopify:section:load', fillSelectedBike);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-contact-support"] && !Shopify.designMode) return;
  try {
    
(() => {
  const updateDetails = (root) => {
    const topic = root.querySelector('[data-pnm-clean-topic]');
    if (!topic) return;

    const kind = topic.selectedOptions[0]?.dataset.kind || '';

    root.querySelectorAll('[data-pnm-clean-details]').forEach((group) => {
      const visible = group.dataset.pnmCleanDetails.split(' ').includes(kind);

      group.hidden = !visible;

      group.querySelectorAll('input').forEach((input) => {
        input.disabled = !visible;
      });
    });

    const hint = root.querySelector('[data-pnm-clean-hint]');

    if (hint) {
      hint.textContent = hint.dataset[kind] || hint.dataset.default;
    }
  };

  const setup = () => {
    document.querySelectorAll('[data-pnm-clean]').forEach((root) => {
      if (!root.dataset.pnmCleanReady) {
        root.dataset.pnmCleanReady = 'true';

        root.querySelector('[data-pnm-clean-topic]')
          ?.addEventListener('change', () => updateDetails(root));

        root.querySelector('[data-pnm-clean-status]')?.focus();
      }

      updateDetails(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
  window.addEventListener('pageshow', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-home-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new WeakMap();
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLElement) || !item.matches('.pnm-home-faq__item')) return;
    const panel = item.querySelector('.pnm-home-faq__reveal');
    if (!panel) return;
    const previous = active.get(panel);
    if (previous) {
      previous.cancel();
      active.delete(panel);
    }
    if (!item.open || motion.matches || typeof panel.animate !== 'function') return;
    const height = panel.getBoundingClientRect().height;
    if (height <= 0) return;
    const animation = panel.animate([
      { height: '0px', opacity: 0, overflow: 'hidden' },
      { height: height + 'px', opacity: 1, overflow: 'hidden' }
    ], { duration: 190, easing: 'cubic-bezier(.2,.7,.2,1)' });
    active.set(panel, animation);
    animation.onfinish = () => active.delete(panel);
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-model-directory"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-model-directory]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('input[type="search"]');
    const search = root.querySelector('[data-directory-search]');
    const status = root.querySelector('[data-directory-status]');
    const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    const items = Array.from(root.querySelectorAll('[data-directory-item]')).map(node => ({node, text:normalize(node.textContent)}));
    const families = Array.from(root.querySelectorAll('[data-directory-family]'));
    const brands = Array.from(root.querySelectorAll('[data-directory-brand]'));
    const update = () => {
      const term = normalize(input.value);
      let count = 0;
      items.forEach(item => {item.node.hidden = Boolean(term && !item.text.includes(term)); if (!item.node.hidden) count++;});
      families.forEach(family => {family.hidden = !family.querySelector('[data-directory-item]:not([hidden])');family.open = Boolean(term && !family.hidden);});
      brands.forEach(brand => {brand.hidden = !brand.querySelector('[data-directory-family]:not([hidden])');});
      root.querySelector('[data-directory-empty]').hidden = count > 0;
      status.textContent = term ? count + ' ' + status.dataset.resultLabel : '';
    };
    search.hidden = false;
    input.addEventListener('input', update);
    root.querySelector('[data-directory-clear]').addEventListener('click', () => {input.value = '';update();input.focus();});
    root.querySelectorAll('.pnm-directory__jump a[href^="#"]').forEach(link => link.addEventListener('click', () => {if(input.value){input.value='';update();}}));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pnm-rm250-hub"]) return;
  try {
    
(() => {
  const hub = document.querySelector('[data-rm250-hub]');
  if (!hub) return;
  const current = new URL(location.href);
  const base = hub.dataset.rmBase;
  const preview = current.searchParams.get('preview_theme_id');
  function preservePreview(url) { if (preview) url.searchParams.set('preview_theme_id', preview); return url; }
  const form = hub.querySelector('[data-rm-year-form]');
  function yearURL(year) {
    const tags = [];
    if (year) tags.push('rm250-' + year);
    if (hub.dataset.rmCategory) tags.push(hub.dataset.rmCategory);
    const url = new URL(base + (tags.length ? '/' + tags.join('+') : ''), location.origin);
    if (current.searchParams.has('sort_by')) url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    url.hash = 'rm250-parts';
    return preservePreview(url);
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    location.assign(yearURL(form.querySelector('[data-rm-year]').value).href);
  });
  const queryYear = current.searchParams.get('rm_year');
  if (queryYear && /^(197[6-9]|19[89]\d|200[0-8])$/.test(queryYear)) {
    location.replace(yearURL(queryYear).href);
    return;
  }
  const sortForm = hub.querySelector('[data-rm-sort-form]');
  sortForm.addEventListener('submit', event => {
    event.preventDefault();
    const url = new URL(location.pathname, location.origin);
    url.searchParams.set('sort_by', sortForm.querySelector('[data-rm-sort]').value);
    url.hash = 'rm250-parts';
    location.assign(preservePreview(url).href);
  });
  hub.querySelectorAll('a[href]').forEach(link => {
    const url = new URL(link.href, location.origin);
    if (url.origin === location.origin && !link.getAttribute('href').startsWith('#')) {
      if (url.pathname.startsWith(base) && current.searchParams.has('sort_by')) url.searchParams.set('sort_by', current.searchParams.get('sort_by'));
      link.href = preservePreview(url).href;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-page"]) return;
  try {
    
(() => {
  if (customElements.get('pnm-build-list')) return;

  const clean=value=>String(value||'').replace(/\s+/g,' ').trim();
    function safeReferenceLabel(label,number) {
      if (!/\bOEM\b/i.test(label)) return label;
      const nonOEM=/^(?:(?:19|20)\d{2}-\d{2,4}[A-Z]*|\d{4}-2RS(?:-\d{4})?|\d{2}-\d{4}[A-Z]?(?:-\d+PC)?|00\d-\d{4}|\dX\d{2}-\d{4}|\d+X-\d+X\d+|\d+V-\d+|(?:SHOP|TUNE|KTM)-\d{4}(?:-\d{2})?|LONG-\d+|GS400-1100|WING-GL1000|VB1-AND-VBC)$/i;
      return nonOEM.test(number.trim()) ? 'Reference' : label;
    }
    function titleParts(source,tags) {
      let name=clean(source),label='',number='';
      const reference=name.match(/\s+(?:[-–—]|\|)\s+((?:Replaces\s+|Genuine\s+)?(?:Honda|Yamaha|Kawasaki|Suzuki)?\s*OEM|(?:OEM\s+)?Ref(?:erence)?(?:\s*(?:No\.?|Number|#))?)\s*[:#]?\s*([A-Z0-9][A-Z0-9\s,./–-]*\d[A-Z0-9\s,./–-]*)$/i);
      const bare=name.match(/\s+\|\s+([A-Z0-9]{3,8}(?:-[A-Z0-9]{2,8}){1,4})$/i);
      if(reference){label=clean(reference[1]);number=clean(reference[2]);name=name.slice(0,reference.index).trim();}
      else if(bare){label='Reference';number=bare[1];name=name.slice(0,bare.index).trim();}
      label=safeReferenceLabel(label,number);
      const originalName=name;
      const knownModels=tags.map(t=>t.match(/^(.+?)\s*\(\d{4}\)$/)?.[1]).filter(Boolean).sort((a,b)=>b.length-a.length);
      let removed=false;
      while(name) {
        const generic=name.match(/^(?:Vintage Japanese Motorcycles?|Vintage Japanese|Honda|Yamaha|Kawasaki|Suzuki|Motorcycles?|ATV|Universal|Gold Wing|Goldwing)\b\s*/i);
        const year=name.match(/^(?:(?:19|20)\d{2}(?:[-–](?:\d{4}|\d{2}))?|\((?:19|20)\d{2}[\d\s,–-]*\))\s+/);
        const model=knownModels.find(m=>name.toLowerCase().startsWith(m.toLowerCase()) && /^[\s,/&]/.test(name.slice(m.length,m.length+1)));
        const code=name.match(/^[A-Z]{1,5}\d{2,4}[A-Z0-9]*(?:\/[A-Z]{0,5}\d{2,4}[A-Z0-9]*)?(?=\s|[,/&])\s*/);
        const length=generic?.[0].length||year?.[0].length||model?.length||code?.[0].length||0;
        if(!length)break;
        name=name.slice(length).replace(/^[\s,/&]+/,'');removed=true;
      }
      if(!name || /^(?:[-–—]|mm\b|Type\b|Style\b)/i.test(name))return {name:originalName,catalogName:originalName,label,number,neutral:false};
      return {name,catalogName:originalName,label,number,neutral:removed || !/\b(?:Honda|Yamaha|Kawasaki|Suzuki|CB\d|GL\d|XS\d)\b/i.test(name)};
    }

  function buildTitle(product) {
    const source=clean(product.title);
    const bike=window.PNMBikeSelector?.selection();
    const tags=Array.isArray(product.tags)?product.tags:[];
    if(!bike?.brand || !bike.model || !/^\d{4}$/.test(String(bike.year||'')))return source;
    const brand=clean(bike.brand).replace(/(?: -)? ATV$/i,'');
    const fits=tags.includes(bike.model+' ('+bike.year+')') && tags.some(tag=>clean(tag).replace(/(?: -)? ATV$/i,'').toLowerCase()===brand.toLowerCase());
    const excluded=tags.some(tag=>/\buniversal\b|^tools?$/i.test(tag)) || /\b(?:universal|tools?)\b/i.test(source);
    if(!fits || excluded)return source;
    const parts=titleParts(source,tags);
    if(!parts.neutral)return source;
    return brand+' '+bike.model+' '+parts.name+(parts.number?' — '+[parts.label,parts.number].filter(Boolean).join(' '):'');
  }

  class PNMBuildList extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-build-config]').textContent);
      this.labels = this.config.labels;
      this.root = window.Shopify?.routes?.root || this.config.root;
      if (!this.root.endsWith('/')) this.root += '/';
      this.entries = new Map();
      this.busy = false;
      this.version = 0;
      this.undoItems = null;
      this.memoryItems = [];
      this.meta = this.readJSON('pnm_build_list_v1', {});
      if (!this.meta || typeof this.meta !== 'object' || Array.isArray(this.meta)) this.meta = {};
      if (!this.meta.parts || typeof this.meta.parts !== 'object') this.meta.parts = {};
      this.listName = typeof this.meta.name === 'string' && this.meta.name.trim() ? this.meta.name.trim().slice(0,60) : this.labels.default_name;
      this.find('name').textContent = this.listName;
      this.find('name-form').elements.build_name.value = this.listName;
      this.find('rename').addEventListener('click', () => this.editName(true));
      this.find('name-cancel').addEventListener('click', () => this.editName(false));
      this.find('name-form').addEventListener('submit', event => {
        event.preventDefault();
        this.listName = this.find('name-form').elements.build_name.value.trim().slice(0,60) || this.labels.default_name;
        this.meta.name = this.listName;
        this.saveMeta();
        this.find('name').textContent = this.listName;
        this.editName(false);
        this.updateEmail();
      });
      this.find('select-all').addEventListener('change', event => {
        this.entries.forEach(entry => { if (this.canAdd(entry)) entry.selected = event.target.checked; });
        this.update();
      });
      this.find('add-all').addEventListener('click', () => this.addToCart(this.selectedEntries()));
      this.find('print').addEventListener('click', () => window.print());
      this.find('email').addEventListener('click', event => {
        this.updateEmail();
        if (this.emailTooLong) { event.preventDefault(); this.notice(this.labels.email_long,true); }
      });
      const clearDialog=this.find('clear-dialog');
      clearDialog.addEventListener('close',()=>{if(!clearDialog.open)clearDialog.hidden=true;});
      this.find('clear').addEventListener('click', () => {clearDialog.hidden=false;clearDialog.showModal();});
      this.find('clear-cancel').addEventListener('click', () => this.find('clear-dialog').close());
      this.find('clear-confirm').addEventListener('click', () => {
        this.find('clear-dialog').close();
        this.undoItems = this.handles().slice();
        this.writeItems([]);
        this.sync();
        this.notice(this.labels.cleared,false,true);
      });
      this.find('undo').addEventListener('click', () => {
        if (!this.undoItems) return;
        this.writeItems([...new Set([...this.undoItems,...this.handles()])]);
        this.undoItems = null;
        this.find('notice').hidden = true;
        this.sync();
      });
      this.onStorage = event => {
        if (event.key === 'items' || event.key === null) this.sync();
      };
      this.onWishlist = () => { if (!this.writingItems) this.sync(); };
      window.addEventListener('storage',this.onStorage);
      document.addEventListener('pnm:wishlist:change',this.onWishlist);
      this.onBikeChange=()=>this.entries.forEach(entry=>{
        const title=entry.row.querySelector('.pnm-build__title');
        if(entry.status==='ready' && title)title.textContent=buildTitle(entry.product);
      });
      window.addEventListener('pnm:bike-change',this.onBikeChange);
      window.addEventListener('pageshow',this.onBikeChange);
      this.sync();
      this.updateContinue();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => this.updateContinue(),{once:true});
    }
    disconnectedCallback() {
      window.removeEventListener('pnm:bike-change',this.onBikeChange);
      window.removeEventListener('pageshow',this.onBikeChange);
      window.removeEventListener('storage',this.onStorage);
      document.removeEventListener('pnm:wishlist:change',this.onWishlist);
    }
    find(name) { return this.querySelector('[data-build-'+name+']'); }
    text(key,values={}) { return Object.entries(values).reduce((s,[k,v])=>s.replaceAll('{'+k+'}',String(v)),this.labels[key] || key); }
    el(tag,cls,text) {
      const node=document.createElement(tag);
      if (cls) node.className=cls;
      if (text !== undefined) node.textContent=text;
      return node;
    }
    button(text,cls,action) {
      const node=this.el('button',cls,text); node.type='button'; node.addEventListener('click',action); return node;
    }
    readJSON(key,fallback) {
      try { const raw=localStorage.getItem(key); return raw === null ? fallback : JSON.parse(raw); }
      catch { this.storageError(); return fallback; }
    }
    storageError() { const error=this.find('storage-error'); if (error) error.hidden=false; }
    handles() {
      if (this.memoryOnly) return this.memoryItems;
      const items=this.readJSON('items',this.memoryItems);
      if (!Array.isArray(items)) { this.storageError(); return this.memoryItems; }
      return [...new Set(items.filter(item=>typeof item === 'string' && item.trim()))];
    }
    writeItems(items) {
      this.memoryItems=items;
      try { localStorage.setItem('items',JSON.stringify(items)); }
      catch { this.memoryOnly=true;this.storageError(); }
      this.writingItems=true;
      document.dispatchEvent(new CustomEvent('pnm:wishlist:change'));
      this.writingItems=false;
    }
    saveMeta() {
      try { localStorage.setItem('pnm_build_list_v1',JSON.stringify(this.meta)); }
      catch { this.storageError(); }
    }
    editName(open) {
      this.find('name-display').hidden=open;
      this.find('name-form').hidden=!open;
      if (open) { this.find('name-form').elements.build_name.value=this.listName; this.find('name-form').elements.build_name.focus(); }
      else this.find('rename').focus();
    }
    updateContinue() {
      const safeURL = value => {
        if (typeof value !== 'string' || !value.trim()) return null;
        try {
          const url = new URL(value,location.origin);
          return url.origin === location.origin && /^https?:$/.test(url.protocol) && (url.pathname==='/'||/^\/(?:collections|products)(?:\/|$)/.test(url.pathname)||url.pathname==='/search') ? url : null;
        } catch (_) { return null; }
      };
      const isWishlist = url => /\/pages\/wish-list\/?$/.test(url.pathname) || url.pathname === location.pathname;
      const shopping=window.PNMShoppingReturn?.url();
      if(shopping){this.querySelectorAll('[data-build-continue]').forEach(link=>link.href=shopping);return;}
      let saved = null;
      try {
        const record = JSON.parse(sessionStorage.getItem('pnm_wishlist_last_page_v1') || 'null');
        const age = Date.now() - record?.time;
        if (Number.isFinite(age) && age >= 0 && age < 24*60*60*1000) {
          const url = safeURL(record.url);
          if (url && !isWishlist(url)) saved = url;
        }
      } catch (_) {}
      const referrer = safeURL(document.referrer);
      let target = referrer && !isWishlist(referrer) ? referrer : null;
      if (target && saved && target.pathname+target.search === saved.pathname+saved.search) target = saved;
      if (!target && (!document.referrer || referrer && isWishlist(referrer))) target = saved;
      if (!target) {
        try { target = safeURL(window.PNMEasyShopping?.allPartsURL()); }
        catch (_) {}
      }
      if (target && !isWishlist(target)) {
        const href = target.pathname+target.search+target.hash;
        this.querySelectorAll('[data-build-continue]').forEach(link=>{link.href=href;});
      }
    }
    notice(message,error=false,undo=false) {
      this.find('message').textContent=message;
      this.find('notice').hidden=false;
      this.find('notice').classList.toggle('pnm-build__notice--error',error);
      this.find('undo').hidden=!undo;
    }
    async request(path,options={}) {
      const controller=new AbortController();
      const timeout=setTimeout(()=>controller.abort(),20000);
      try {
        const response=await fetch(this.root+path,{credentials:'same-origin',...options,signal:controller.signal});
        const data=await response.json();
        if (!response.ok) {
          const error=new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : this.labels.cart_error);
          error.status=response.status; throw error;
        }
        return data;
      } finally { clearTimeout(timeout); }
    }
    async sync() {
      const version=++this.version;
      const handles=this.handles();
      for (const [handle,entry] of this.entries) if (!handles.includes(handle)) {entry.row.remove();this.entries.delete(handle);}
      const pending=[];
      for (const handle of handles) {
        let entry=this.entries.get(handle);
        if (!entry) {
          entry={handle,quantity:1,selected:true,product:null,status:'loading',row:this.el('article','pnm-build__row')};
          this.entries.set(handle,entry); pending.push(entry); this.renderPending(entry);
        }
        this.find('rows').append(entry.row);
      }
      this.find('loading').hidden=!pending.length;
      this.update();
      let index=0;
      const worker=async () => {
        while (index<pending.length) {
          const entry=pending[index++];
          await this.loadEntry(entry);
          this.update();
        }
      };
      await Promise.all(Array.from({length:Math.min(4,pending.length)},worker));
      if (version === this.version) {this.find('loading').hidden=true;this.update();}
    }
    renderPending(entry) {
      entry.row.replaceChildren();
      const message=this.el('p','pnm-build__row-error',this.labels.loading);
      entry.row.append(message);
    }
    async loadEntry(entry) {
      entry.status='loading';
      try {
        const product=await this.request('products/'+encodeURIComponent(entry.handle)+'.js');
        if (!product || !Array.isArray(product.variants) || !product.variants.length) throw new Error(this.labels.load_error);
        entry.product=product;
        const saved=this.meta.parts[entry.handle] || {};
        entry.variant=product.variants.length === 1 ? product.variants[0] : product.variants.find(v=>String(v.id)===String(saved.variant)) || null;
        entry.quantity=Number.isSafeInteger(saved.quantity) && saved.quantity>0 ? saved.quantity : 1;
        const rule=this.rule(entry);
        if (entry.quantity<rule.min || (entry.quantity-rule.min)%rule.step || (rule.max && entry.quantity>rule.max)) entry.quantity=rule.min;
        entry.status='ready';
        this.renderEntry(entry);
      } catch(error) {
        entry.status=error.status === 404 ? 'missing' : 'error';
        entry.row.classList.add('pnm-build__row--error');
        entry.row.replaceChildren();
        const title=this.el('a','pnm-build__title',entry.handle.replaceAll('-',' ')); title.href=this.root+'products/'+encodeURIComponent(entry.handle);
        const detail=this.el('div','pnm-build__detail'); detail.append(title,this.el('p','',this.labels[entry.status === 'missing' ? 'missing' : 'load_error']));
        const actions=this.el('div','pnm-build__actions');
        if (entry.status !== 'missing') actions.append(this.button(this.labels.retry,'pnm-build__button',async()=>{this.renderPending(entry);await this.loadEntry(entry);this.update();}));
        actions.append(this.button(this.labels.remove,'pnm-build__text-button',()=>this.removeEntry(entry)));
        entry.row.append(detail,actions);
      }
    }
    rule(entry) {
      const rule=entry.variant?.quantity_rule || {};
      return {min:Number.isSafeInteger(rule.min)&&rule.min>0?rule.min:1,step:Number.isSafeInteger(rule.increment)&&rule.increment>0?rule.increment:1,max:Number.isSafeInteger(rule.max)&&rule.max>0?rule.max:null};
    }
    canAdd(entry) { return entry.status === 'ready' && !!entry.variant?.available && !entry.product?.requires_selling_plan; }
    selectedEntries() { return [...this.entries.values()].filter(entry=>this.canAdd(entry)&&entry.selected); }
    rememberEntry(entry) {
      this.meta.parts[entry.handle]={quantity:entry.quantity,variant:entry.variant?.id || null}; this.saveMeta();
    }
    money(target,cents) {
      const span=this.el('span','money');
      const format=window.theme?.Currency?.formatMoney;
      if (format) {
        const temp=this.el('div'); temp.innerHTML=format(cents,this.config.money_format); span.textContent=temp.textContent;
      } else {
        span.textContent=new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.config.currency,currencyDisplay:'narrowSymbol'}).format(cents/100);
      }
      target.replaceChildren(span);
    }
    convertMoney() {
      try {
        const target=window.Currency?.currentCurrency;
        if (target && window.Currency?.convertAll && (window.show_multiple_currencies || window.show_auto_currency)) window.Currency.convertAll(this.config.currency,target,'#PNMBuildList span.money','money_format');
      } catch {}
    }
    renderEntry(entry) {
      const p=entry.product;
      entry.add=null;entry.select=null;
      entry.row.classList.remove('pnm-build__row--error');
      entry.row.replaceChildren(); entry.row.setAttribute('aria-label',p.title);
      const check=this.el('input');check.type='checkbox';check.setAttribute('aria-label',this.text('select',{title:p.title}));
      check.addEventListener('change',()=>{entry.selected=check.checked;this.update();});entry.check=check;
      const imageLink=this.el('a','pnm-build__image'); imageLink.href=this.root+'products/'+encodeURIComponent(entry.handle); imageLink.setAttribute('aria-label',p.title);
      const src=entry.variant?.featured_image?.src || p.featured_image;
      if (src) {
        const image=this.el('img'); image.src=src; image.alt=p.title; image.width=104;image.height=104;image.loading='lazy';
        image.addEventListener('error',()=>{imageLink.replaceChildren(this.el('span','pnm-build__image-placeholder',this.labels.view));},{once:true});imageLink.append(image);
      } else imageLink.append(this.el('span','pnm-build__image-placeholder',this.labels.view));
      const detail=this.el('div','pnm-build__detail');
      const title=this.el('a','pnm-build__title',buildTitle(p));title.href=imageLink.href;
      detail.append(title);
      if (entry.variant?.sku) detail.append(this.el('p','pnm-build__sku',this.labels.sku+' '+entry.variant.sku));
      const available=entry.variant ? entry.variant.available : p.available;
      detail.append(this.el('span','pnm-build__stock'+(available?'':' pnm-build__stock--unavailable'),available?this.labels.available:this.labels.unavailable));
      if (p.variants.length>1) {
        const label=this.el('label','pnm-build__variant-label',this.labels.choose);
        const select=this.el('select');select.setAttribute('aria-label',this.text('options',{title:p.title}));
        const placeholder=this.el('option','',this.labels.choose); placeholder.value='';select.append(placeholder);
        p.variants.forEach(variant=>{const option=this.el('option','',variant.title+(variant.available?'':' — '+this.labels.unavailable));option.value=String(variant.id);select.append(option);});
        select.value=entry.variant ? String(entry.variant.id) : '';
        select.addEventListener('change',()=>{
          entry.variant=p.variants.find(v=>String(v.id)===select.value)||null;
          entry.quantity=this.rule(entry).min;
          this.rememberEntry(entry);this.renderEntry(entry);this.update();
        });
        label.append(select);detail.append(label);entry.select=select;
      }
      const price=this.el('div','pnm-build__price'); const amount=this.el('div');
      if (entry.variant) this.money(amount,entry.variant.price);
      else this.money(amount,p.price_min);
      price.append(amount,this.el('small',entry.variant?'pnm-build__unit-label':'',entry.variant?this.labels.each:this.labels.choose));
      const qty=this.el('div','pnm-build__qty');
      const decrease=this.button('−','',()=>this.setQuantity(entry,entry.quantity-this.rule(entry).step));decrease.setAttribute('aria-label',this.text('decrease',{title:p.title}));
      const input=this.el('input');input.type='number';input.inputMode='numeric';input.value=String(entry.quantity);const rule=this.rule(entry);input.min=String(rule.min);input.step=String(rule.step);if(rule.max)input.max=String(rule.max);input.setAttribute('aria-label',this.text('qty_label',{title:p.title}));
      input.addEventListener('change',()=>this.setQuantity(entry,Number(input.value)));
      const increase=this.button('+','',()=>this.setQuantity(entry,entry.quantity+this.rule(entry).step));increase.setAttribute('aria-label',this.text('increase',{title:p.title}));
      qty.append(decrease,input,increase);entry.qtyInput=input;entry.decrease=decrease;entry.increase=increase;
      const actions=this.el('div','pnm-build__actions');
      if (!entry.variant || p.requires_selling_plan) {
        const view=this.el('a','pnm-build__button',this.labels.choose);view.href=imageLink.href;actions.append(view);
      } else {
        const add=this.button(this.labels.add,'pnm-build__button pnm-build__primary',()=>this.addToCart([entry]));actions.append(add);entry.add=add;
      }
      const remove=this.button(this.labels.remove,'pnm-build__text-button',()=>this.removeEntry(entry));remove.setAttribute('aria-label',this.text('remove_label',{title:p.title}));actions.append(remove);entry.remove=remove;
      entry.row.append(check,imageLink,detail,price,qty,actions);
    }
    setQuantity(entry,quantity) {
      const rule=this.rule(entry);
      if (!Number.isSafeInteger(quantity) || quantity<rule.min || (quantity-rule.min)%rule.step || (rule.max && quantity>rule.max)) {
        entry.qtyInput.value=String(entry.quantity);
        this.notice(this.text('qty_invalid',rule),true);return false;
      }
      entry.quantity=quantity;entry.qtyInput.value=String(quantity);this.rememberEntry(entry);this.update();return true;
    }
    removeEntry(entry) {
      if (this.busy) return;
      this.undoItems=[entry.handle];
      this.writeItems(this.handles().filter(handle=>handle!==entry.handle));
      this.sync();this.notice(this.labels.removed,false,true);
      this.find('undo').focus();
    }
    update() {
      const entries=[...this.entries.values()];
      const count=entries.length;
      this.find('loading').hidden=!entries.some(entry=>entry.status==='loading');
      const ready=entries.filter(entry=>this.canAdd(entry));
      const selected=this.selectedEntries();
      this.find('empty').hidden=count!==0;
      ['summary','toolbar','columns','footer'].forEach(name=>{this.find(name).hidden=count===0;});
      this.find('count').textContent=count===1?this.labels.saved_one:this.text('saved_many',{count});
      this.find('selected').textContent=this.text('selected',{count:selected.length});
      const total=selected.reduce((sum,entry)=>sum+entry.variant.price*entry.quantity,0);
      this.money(this.find('total'),total);
      const all=this.find('select-all');all.disabled=!ready.length||this.busy;all.checked=ready.length>0&&selected.length===ready.length;all.indeterminate=selected.length>0&&selected.length<ready.length;
      const main=this.find('add-all');main.disabled=!selected.length||this.busy;main.textContent=this.busy?this.labels.adding: selected.length===count?this.labels.add_all:this.labels.add_selected;
      this.find('selection-note').hidden=!count||ready.length===count;
      this.find('clear').disabled=this.busy;
      entries.forEach(entry=>{
        if (entry.status!=='ready') return;
        const can=this.canAdd(entry),rule=this.rule(entry);
        entry.check.disabled=!can||this.busy;entry.check.checked=can&&entry.selected;
        if (entry.add) {entry.add.disabled=!can||this.busy;entry.add.textContent=can?this.labels.add:this.labels.unavailable;}
        entry.qtyInput.disabled=!can||this.busy;
        entry.decrease.disabled=!can||this.busy||entry.quantity<=rule.min;
        entry.increase.disabled=!can||this.busy||!!(rule.max&&entry.quantity>=rule.max);
        if(entry.select)entry.select.disabled=this.busy;
        entry.remove.disabled=this.busy;
      });
      this.updateEmail(); this.convertMoney();
    }
    updateEmail() {
      let body=this.listName+'\n'+this.labels.email_intro+'\n\n';
      this.entries.forEach(entry=>{
        const p=entry.product;
        body+=(p?.title || entry.handle)+'\n';
        if(entry.variant?.sku)body+=this.labels.sku+' '+entry.variant.sku+'\n';
        if(entry.variant && p.variants.length>1)body+=entry.variant.title+'\n';
        body+=this.labels.quantity+': '+entry.quantity+'\n'+location.origin+this.root+'products/'+encodeURIComponent(entry.handle)+(entry.variant?'?variant='+entry.variant.id:'')+'\n\n';
      });
      body+=this.labels.email_total+' '+(this.find('total')?.textContent || '');
      const href='mailto:?subject='+encodeURIComponent(this.labels.email_subject+' — '+this.listName)+'&body='+encodeURIComponent(body);
      this.emailTooLong=href.length>7500;
      this.find('email').href=this.emailTooLong?'mailto:':href;
    }
    async addToCart(entries) {
      if(this.busy)return;
      const chosen=entries.filter(entry=>this.canAdd(entry));
      if(!chosen.length){this.notice(this.labels.no_selection,true);return;}
      for(const entry of chosen) {
        if(Number(entry.qtyInput.value)!==entry.quantity && !this.setQuantity(entry,Number(entry.qtyInput.value)))return;
      }
      const items=chosen.map(entry=>({id:entry.variant.id,quantity:entry.quantity}));
      this.busy=true;this.update();this.notice(this.labels.adding);
      let added=false;
      try {
        await this.request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
        added=true;
      } catch(error) {
        const message=error.status ? this.labels.cart_error+' '+error.message : this.labels.cart_check;
        this.notice(message,true);
      }
      if(added){
        this.notice(chosen.length===1?this.labels.added:this.text('added_many',{count:chosen.length}));
        try {
          const cart=await this.request('cart.js');
          document.querySelectorAll('[data-cart-count]').forEach(node=>{node.textContent=String(cart.item_count);});
          if(typeof window.upcartRefreshCart==='function') await window.upcartRefreshCart();
          if(typeof window.upcartOpenCart==='function')window.upcartOpenCart();
          else {
            const trigger=[...document.querySelectorAll('[data-cart-preview],[data-cart-preview-pc]')].find(node=>node.getClientRects().length);
            if(trigger)trigger.click();
          }
        } catch { this.notice(this.labels.added+' '+this.labels.cart_check,true); }
      }
      this.busy=false;this.update();
    }
  }
  customElements.define('pnm-build-list',PNMBuildList);
})();


  } catch(e) { console.error(e); }
})();
})();
